import { createActions, } from 'redux-actions';

export default createActions({
  INSURANCE: {
    REQUEST: null,
    SEND: null,
  },
});
